import { IPPanel, IPPanelType } from 'baseComponents/Panel/IPPanel';
import { IPStack } from 'baseComponents/Stack/IPStack';
import { globalNavBarHeight } from 'globalConstants';
import NavMain from './NavMain';
import { navPanelStyles } from './navMainStyles';

interface INavRootOverlayProps {
  onClose: () => void;
}

//
// The full menu, shown over the page while the pointer rests on the compact rail. It does not dim
// the page behind it.
//
const NavRootOverlay = (props: INavRootOverlayProps) => {
  return (
    <IPPanel
      isOpen={true}
      type={IPPanelType.smallFixedNear}
      hasCloseButton={false}
      isBlocking={false}
      // Escape closes the flyout. Without this Fluent closes and reopens it from the isOpen prop.
      onDismiss={() => props.onClose()}
      styles={{
        ...navPanelStyles,
        root: { top: globalNavBarHeight },
        commands: { display: 'none' },
      }}
    >
      <IPStack verticalFill onMouseLeave={() => props.onClose()}>
        <NavMain presentation="full" />
      </IPStack>
    </IPPanel>
  );
};

export default NavRootOverlay;
